import { graphql, useStaticQuery } from 'gatsby'
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react'

// Import Swiper styles
import 'swiper/css'

import ParseContent from 'components/shared/ParseContent'
import Plaatjie from '@ubo/plaatjie'
import styled from 'styled-components'

import Vector from 'img/WerkwijzeVector.svg'
import EndlessContainer from './elements/EndlessContainer'

const StepNumber = styled.span`
  font-size: 85px;
  line-height: 48px;
  color: #d4d7d2;
  font-weight: 900;
  z-index: 9;
  position: absolute;
  left: 60px;
`

const Image = styled(Plaatjie)`
  margin-left: -50px;
`

const CustomStepNumber = styled.span`
  font-size: 85px;
  line-height: 48px;
  color: #d4d7d2;
  font-weight: 900;
  z-index: 9;
  margin-left: -50px;
  position: absolute;
`

const Slider = styled(Swiper)`
  & .swiper-wrapper::before {
    content: '';
    background: url(${Vector}) no-repeat;
    width: 2370px;
    height: 202px;
    background-size: 100%;
    display: block;
    position: absolute;
    background-position: 0 -110%;

    @media (max-width: 991px) {
      display: none;
    }

    @media (min-width: 991px) and (max-width: 1599px) {
      width: 2140px;
      height: 182px;
    }
  }

  & h3 {
    font-size: 26px !important;
    line-height: 45px;
    font-weight: 700 !important;

    @media (max-width: 991px) {
      font-size: 18px !important;
      line-height: 33px !important;
    }
  }
`

const OnzeWerkwijze = ({ id }) => {
  const { werkwijze } = useStaticQuery(graphql`
    {
      werkwijze: allWpComponent(filter: { databaseId: { in: [2510, 2542] } }) {
        edges {
          node {
            databaseId
            componentWerkwijze {
              fieldGroupName
              title
              steps {
                number
                description
                image {
                  localFile {
                    childImageSharp {
                      gatsbyImageData(width: 217, quality: 100)
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  `)

  const data = werkwijze.edges.find(({ node }) => node.databaseId === id)

  if (!data) {
    return null
  }

  return (
    <section>
      <div className="container">
        <div className="row">
          <div className="col-12">
            <ParseContent content={data.node.componentWerkwijze.title} />
          </div>
        </div>
      </div>
      <EndlessContainer>
        <Slider
          grabCursor={true}
          className="py-5"
          breakpoints={{
            320: {
              slidesPerView: 1.25,
              spaceBetween: 20,
            },
            640: {
              slidesPerView: 2.5,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 3.5,
              spaceBetween: 20,
            },
          }}
        >
          {data.node.componentWerkwijze.steps.map((step, index) => (
            <SwiperSlide key={index}>
              <div className="d-flex flex-column align-items-center">
                {index % 2 == 0 ? (
                  <>
                    <div className="mb-4">
                      <StepNumber>0{step.number}</StepNumber>
                      <Image image={step.image} />
                    </div>
                    <ParseContent content={step.description} />
                  </>
                ) : (
                  <>
                    <div className="d-flex align-items-end justify-content-end mb-4">
                      <Plaatjie image={step.image} />
                      <CustomStepNumber>0{step.number}</CustomStepNumber>
                    </div>
                    <ParseContent content={step.description} />
                  </>
                )}
              </div>
            </SwiperSlide>
          ))}
        </Slider>
      </EndlessContainer>
    </section>
  )
}

export default OnzeWerkwijze
